import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { SimpleProperty } from '@core';
import { AlertComponent, CheckboxWrappedComponent, NumericInputStepperComponent } from '@ui';

@Component({
  selector: 'sbnb-add-task-rule-flow-cleaning-details',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatCheckboxModule,
    NumericInputStepperComponent,
    CheckboxWrappedComponent,
    AlertComponent,
  ],
  templateUrl: './add-task-rule-flow-cleaning-details.component.html',
})
export class AddTaskRuleFlowCleaningDetailsComponent {
  // Inputs
  property = input<SimpleProperty | null>();
  rooms = input.required<number>();
  bathrooms = input.required<number>();
  cleaningHours = input.required<number>();
  recommendedCleaningTime = input<number | null>(null);
  provideCleaningSupplies = input.required<boolean>();
  turnoIntegrationEnabled = input<boolean>(false);
  cleansterIntegrationEnabled = input<boolean>(false);
  resortCleaningIntegrationEnabled = input<boolean>(false);
  tidyIntegrationEnabled = input<boolean>(false);

  // Outputs - only for editable fields
  cleaningHoursChanged = output<number>();
  provideCleaningSuppliesChanged = output<boolean>();
}
